import EzTab from './EzTab.vue';
import EzTabs from './EzTabs.vue';

export {
  EzTab,
  EzTabs,
};
